export default "__VITE_ASSET__BBK1Hae9__";